'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var propTypes = _interopDefault(require('prop-types'));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Displays an SVG `img` tag with a country flag.
 * @public
 * @param       {string} country
 * @param       {string} role
 * @param       {number} size
 * @returns     {object}
 * @constructor
 */
function Flag(props) {
  var country = props.country,
      role = props.role,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ['country', 'role', 'size']);

  var flagSrc = require('./img/SVG/' + country + '.svg');
  return React.createElement('img', _extends({
    src: flagSrc,
    role: role,
    alt: country + ' Flag',
    height: size,
    width: size
  }, otherProps));
}

Flag.defaultProps = {
  role: 'img',
  size: 24
};

exports['default'] = Flag;
//# sourceMappingURL=index.js.map
